// @flow
import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer'

import config from 'app/config'
export const dataKey = 'warehouseStock' as const

export type Settings = {
  rows: number
}

export const warehouseStockDefaultState: Settings = {
  rows: config.perPageItems,
}

export default makeSettingsReducer(dataKey, warehouseStockDefaultState)
